module.exports = [{
      plugin: require('/media/svastara/Stranice/hostel-ljubas/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/globals/typography"},
    }]
